module.exports = __webpack_public_path__ + "static/media/logo-company.49d3b05f.svg";